import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { VitalsService } from '../../vitals/services/vitals.service'
import { IPainQualityFieldOptionsResponse } from '../../../common/common.types'
import { setPainQualityFieldOptions } from '../store/options.actions'

export function* getPainQualityFieldOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const response: IPainQualityFieldOptionsResponse = yield call([
      vitalsService,
      vitalsService.getPainQualityFieldOptions,
    ])
    const { entity } = response
    if (entity && entity.length) yield put(setPainQualityFieldOptions(entity[0]))
  } catch (e) {
    yield put(throwPcrException(`getPainQualityFieldOptions() error: ${e}`))
  }
}

export function* getPainQualityFieldOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getPainQualityFieldOptions)
}
